/**
 * List Schema of Administrador
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Administrador} from '@/model/resource/Administrador'

/* TODO: review generated schema */
export class ListAdministradorSchema extends Schema {
  readonly name = 'ListAdministrador'

  readonly fieldSet: FieldSet<Administrador> = {
    idAdministradorPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
  }
}
